
export default function ProgressBar(props) {
  
  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 -mt-4">
      {props.color ? (
        //bg-${partner}-primary
        <div className = "h-2.5 rounded-full" style={{backgroundColor: props.color, width: props.progress, transition: "width 2s" }}></div>
      ) : (
        <div className = "bg-primary-200 h-2.5 rounded-full" style={{ width: props.progress, transition: "width 2s" }}></div>
      )}
      
    </div>
  )
}

